
const eventHandlers = {
  message_count: function (value) {
    this.store.commit('statuses/setMessages', value)
  },
  status_update: function () {
    this.store.dispatch('statuses/getStatuses')
  },
  on_message: function (value) {
    this.store.dispatch('conversations/socket_onMessage', value)
  },
  read_conversation: function (value) {
    this.store.dispatch('conversations/socket_readConversation', value)
  },
  'active:update': function (value) {
    this.store.commit('conversations/setCurrentStatus', value)
  }
}

const sendPing = (conn) => {
  conn.WebSocket.sendObj({type: 'ping'})
}

export default {
  async handler (eventName, event) {
    if (!eventName.startsWith('SOCKET_')) { return }

    if (eventName === 'SOCKET_onopen') {
      window.clearInterval(this.timer)
      this.timer = window.setInterval(() => {
        sendPing(this)
      }, 15000)
    }

    if (event === 'SOCKET_onclose') {
      window.clearInterval(this.timer)
    }

    if (event.data) {
      const data = JSON.parse(event.data)
      const handler = eventHandlers[data.event]
      if (handler) {
        handler.call(this, data.value)
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/socket/index.js